import posthog from 'posthog-js';
import { getAuthUserFromLocalStorage } from './LocalStorage';

export const trackGAEvent = (
  eventName: string,
  params?: Record<string, string | number>
): void => {
  const user = getAuthUserFromLocalStorage();
  const eventParams = { ...params, utm_id: user?.email };

  if (typeof window !== 'undefined' && (window as any).gtag) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window.gtag('event', eventName, eventParams);
  }

  if (posthog.__loaded) {
    posthog.capture(eventName, eventParams);
  }
};

export default trackGAEvent;
